import React from 'react';
import { Box } from '../../../../wag-react/next-components/box';
import { Span } from '../../../../wag-react/core-components/span';
import { Button } from '../../../../wag-react/next-components/button';
import { useMediaQuery } from 'react-responsive';
import { useTheme } from '../../../../hooks/useTheme';
import { ChevronRightIcon } from '../../../../wag-react/next-components/icons';

// Import new caregiver images
import caregiverImage from './assets/Caregiver.jpg';
import { URL_BECOME_WALKER } from '../../../../wag-react/components/site-navigation/urls';
import { Typography } from '../../../../components/Typography';
export const AnimalLoversWantedSection: React.FC = () => {
  const {
    theme: appTheme
  } = useTheme();
  const isMobile = useMediaQuery({
    maxWidth: appTheme?.breakpoints?.[0]
  });
  return <Box width="100%" display="flex" justifyContent="center" px={['16px', '16px']} py={4} data-sentry-element="Box" data-sentry-component="AnimalLoversWantedSection" data-sentry-source-file="AnimalLoversWantedSection.tsx">
      <Box display="flex" flexDirection={['column', 'column', 'row']} width="1150px" maxWidth="100%" justifyContent="center" alignItems="flex-start" overflow="hidden" boxSizing="border-box" data-sentry-element="Box" data-sentry-source-file="AnimalLoversWantedSection.tsx">
        {/* Image Section */}
        <Box width={['100%', '100%', '45%']} height={['264px', '264px', '428px']} order={[1, 1, 1]} mb={[0, 0, 0]} position="relative" style={{
        backgroundImage: `url(${caregiverImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} borderRadius={['20px 20px 0 0', '20px 20px 0 0px', '20px 0 0 20px']} aria-label="Pet caregiver playing with a dog" data-sentry-element="Box" data-sentry-source-file="AnimalLoversWantedSection.tsx" />

        {/* Content Section */}
        <Box width={['100%', '100%', '55%']} order={[2, 2, 2]} display="flex" flexDirection="column" justifyContent="center" alignItems={['flex-start', 'flex-start', 'flex-start']} px={['20px', '20px', '36px']} py={['24px', '24px', 0]} borderRadius={['0 0 20px 20px', '0px 0px 20px 20px', '0px 20px 20px 0']} bg="#3A5080" // funBlue
      mb={3} height={['auto', 'auto', '428px']} style={{
        gap: isMobile ? '20px' : '24px'
      }} data-sentry-element="Box" data-sentry-source-file="AnimalLoversWantedSection.tsx">
          <Box display="flex" flexDirection="column" alignItems="flex-start" mb={3} alignSelf="stretch" style={{
          gap: '18px'
        }} data-sentry-element="Box" data-sentry-source-file="AnimalLoversWantedSection.tsx">
            <Typography color="#FFF" fontFamily='"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' fontSize={['28px', '28px', '36px']} fontWeight={700} lineHeight={['36px', '36px', '44px']} letterSpacing="0px" mb={0} data-sentry-element="Typography" data-sentry-source-file="AnimalLoversWantedSection.tsx">
              Animal lovers wanted!
            </Typography>
            
            <Typography color="#FFF" fontFamily='"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' fontSize="16px" fontWeight={400} lineHeight="24px" letterSpacing="0px" alignSelf="stretch" mb={0} data-sentry-element="Typography" data-sentry-source-file="AnimalLoversWantedSection.tsx">
              Are you a pet lover with pet care experience? Want to earn money working with pets? Learn more about becoming a dog walker, sitter, or trainer in your city.
            </Typography>
          </Box>
          
          <Box width={['100%', 'auto', 'auto']} mt={0} data-sentry-element="Box" data-sentry-source-file="AnimalLoversWantedSection.tsx">
            <Button href={URL_BECOME_WALKER} variant="outlined" className="no-hover" innerProps={{
            className: 'no-hover-inner'
          }} style={{
            display: 'flex',
            width: '100%',
            height: '48px',
            maxWidth: '650px',
            padding: '12px 50px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
            borderRadius: '24px',
            background: '#FAE7A8',
            // wagYellow
            border: 'none',
            cursor: 'pointer'
          }} data-sentry-element="Button" data-sentry-source-file="AnimalLoversWantedSection.tsx">
              <Span color="#7B5533" // wagBrown
            fontFamily='"Hero New", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' fontSize="14px" fontWeight={700} lineHeight="20px" letterSpacing="0px" textAlign="center" style={{
              cursor: 'pointer'
            }} data-sentry-element="Span" data-sentry-source-file="AnimalLoversWantedSection.tsx">
                Become a Pet Caregiver
              </Span>
              <ChevronRightIcon size={20} color="#7B5533" data-sentry-element="ChevronRightIcon" data-sentry-source-file="AnimalLoversWantedSection.tsx" />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>;
};